import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "MainPageBackground" }
const _hoisted_2 = { class: "TopBar" }
const _hoisted_3 = { class: "TopBarContent" }
const _hoisted_4 = { class: "Logo" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "home-particles" }
const _hoisted_7 = {
  id: "section-1",
  class: "full-page-section content-section"
}
const _hoisted_8 = { class: "decorative-sidebar" }
const _hoisted_9 = { class: "product-left" }
const _hoisted_10 = { class: "product-image-wrapper" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "product-right" }
const _hoisted_13 = { class: "game-title" }
const _hoisted_14 = { class: "game-subtitle" }
const _hoisted_15 = { class: "game-desc" }
const _hoisted_16 = { class: "highlight" }
const _hoisted_17 = { class: "game-list-sidebar" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 0,
  class: "info-boxes-wrapper"
}
const _hoisted_21 = {
  key: 1,
  class: "info-boxes-wrapper empty-announcement"
}
const _hoisted_22 = { class: "about-panel-container" }
const _hoisted_23 = { class: "about-navigation" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "card-num" }
const _hoisted_26 = { class: "card-title-group" }
const _hoisted_27 = { class: "card-title" }
const _hoisted_28 = { class: "card-subtitle" }
const _hoisted_29 = { class: "about-details-content" }
const _hoisted_30 = { class: "viewport-main-title" }
const _hoisted_31 = { class: "row-header" }
const _hoisted_32 = { class: "row-title" }
const _hoisted_33 = { class: "row-description" }
const _hoisted_34 = {
  key: 0,
  class: "all-list-overlay"
}
const _hoisted_35 = { class: "all-list-box" }
const _hoisted_36 = { class: "all-list-scroll" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "simple-info" }

import { ref, watch, onMounted, onUnmounted, computed } from "vue";
// 【新增】引入 Vue Router 的 API
import { useRoute, useRouter } from "vue-router";
import useGlobalStateStore, { Enum_Theme } from "@/Store/GlobalStateStore";
import InfoBox_Left from "@/components/InfoBox_Left.vue";
import AnnouncementModal from "@/components/AnnouncementModal.vue";
import { AnOutlinedBilibili, AnOutlinedX, MdEmail, SiSinaweibo, CoBrandYoutube, AnOutlinedClose } from "@kalimahapps/vue-icons";
import { fetchAnnouncements } from "@/server/api";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainPage_CHS',
  setup(__props) {

_useCssVars(_ctx => ({
  "v0f0b2ef0": (ThemeTopBarBackgroundColor.value),
  "v68af4c00": (activeSection.value === 0 ? "none" : "0 2px 4px rgba(0, 0, 0, 0.15)"),
  "db3c8584": (ThemeTopBarColor.value),
  "v18753809": (ThemeItemColor.value),
  "v14e445d6": (ThemeHintColor.value),
  "v79f268b3": (ThemeMainSloganCruxColor.value),
  "v120a3c36": (ThemeMainSloganColor.value),
  "fb988f92": (ThemeSubSlogan.value),
  "v73e8d455": (ThemeIconBackgroundHoverColor.value),
  "v3b31e097": (ThemeBottomBG.value),
  "b2b0491e": (ThemeBottomPartingLine.value),
  "v443eb319": (ThemeCopyrightFiling.value)
}))

const GlobalStyleStore = useGlobalStateStore();
const activeSection = ref(0);
const scrollContainer = ref<HTMLElement | null>(null);

// 【新增】初始化 router 和 route
const route = useRoute();
const router = useRouter();

const isModalVisible = ref(false);
const currentAnnouncementData = ref<any>(null);

// 【修改】打开弹窗时，将当前公告的 ID 写入 URL 参数
function openAnnouncementModal(item: any) {
  currentAnnouncementData.value = item;
  isModalVisible.value = true;

  // 将新闻 ID 同步到浏览器地址栏，使用 replace 不会增加无用的历史记录
  router.replace({ query: { ...route.query, news_id: item.id } });
}

// 【新增】关闭弹窗时，清除 URL 里的 news_id 参数
function closeAnnouncementModal() {
  isModalVisible.value = false;

  const currentQuery = { ...route.query };
  delete currentQuery.news_id; // 移除参数
  router.replace({ query: currentQuery });
}

const ThemeTopBarBackgroundColor = ref("transparent");
const ThemeTopBarColor = ref("#fff");
const ThemeItemColor = ref("#57E1D9");
const ThemeMainSloganColor = ref("#FFF");
const ThemeMainSloganCruxColor = ref("#57E1D9");
const ThemeSubSlogan = ref("#FFF");
const ThemeIconBackgroundColor = ref("#3fb7b0");
const ThemeIconBackgroundHoverColor = ref("#57E1D9");
const ThemeBottomBG = ref("#242424");
const ThemeBottomPartingLine = ref("#FFFFFF26");
const ThemeCopyrightFiling = ref("#FFF");
const ThemeHintColor = ref("#FFF");

// --- 首页 3D 视差追踪逻辑 ---
const mouseX = ref(0);
const mouseY = ref(0);
const isHoveringHome = ref(false);

function onHomeMouseMove(e: MouseEvent) {
  isHoveringHome.value = true;
  const { innerWidth, innerHeight } = window;
  mouseX.value = (e.clientX / innerWidth - 0.5) * 2;
  mouseY.value = (e.clientY / innerHeight - 0.5) * 2;
}

function onHomeMouseLeave() {
  isHoveringHome.value = false;
  mouseX.value = 0;
  mouseY.value = 0;
}

const homeBgLayers = computed(() => {
  const moveX = mouseX.value;
  const moveY = mouseY.value;

  const config = [
    { mult: 0.4, scale: 1.02, opacity: 0.35, blur: '6px', blend: 'normal', hue: 0 },
    { mult: 0.8, scale: 1.06, opacity: 0.50, blur: '3px', blend: 'normal', hue: 15 },
    { mult: 1.3, scale: 1.10, opacity: 0.90, blur: '0px', blend: 'normal', hue: 0 },
    { mult: 2.0, scale: 1.16, opacity: 0.40, blur: '2px', blend: 'screen', hue: -15 },
    { mult: 2.8, scale: 1.25, opacity: 0.25, blur: '10px', blend: 'color-dodge', hue: 30 }
  ];

  return config.map((layer, index) => {
    const x = moveX * layer.mult * 1.5;
    const y = moveY * layer.mult * 1.5;
    return {
      transform: `scale(${layer.scale}) translate(${-x}%, ${-y}%)`,
      transition: isHoveringHome.value ? 'transform 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'transform 2.5s ease-out',
      backgroundImage: "url('/Images/HomeBG.jpg')",
      opacity: layer.opacity,
      filter: `blur(${layer.blur}) hue-rotate(${layer.hue}deg)`,
      mixBlendMode: layer.blend as any,
      zIndex: index + 1
    };
  });
});

// --- 第四页“了解我们”数据与面板内容 ---
const activeAboutTab = ref(0);
const aboutTabsData = [
  {
    num: "01",
    title: "总则",
    subTitle: "GENERAL",
    paragraphs: [
      { label: "企业简介", desc: "游晰概念LESJEUXA成立于2021年，作为一家新世代的游戏创意公司，秉持“技术研发、艺术创造、新文化传播”，致力于为亚洲乃至世界提供卓越且创新的“游晰方案”。" },
      { label: "宗旨与使命", desc: "宗旨：我们以前沿科技为支撑，通过艺术创意激发文化活力，推动游戏产业与文化交流的跨界融合。\n使命：我们以技术创新驱动产品开发，通过艺术表达传递人类理念，借助新媒体与多元平台传播具有全球影响力的新文化。" },
      { label: "愿景", desc: "不断成为每个新时代中引领全球游戏创意与文化传播的先锋企业，实现科技与艺术的完美交融，构建开放、共享、共创的数字生态，并为人类实现真正元宇宙与数字生命的梦想。" }
    ]
  },
  {
    num: "02",
    title: "纲领",
    subTitle: "CREED",
    paragraphs: [
      { label: "技术研发", desc: "我们坚持以科技为先导，不断探索新技术与新方法，在人工智能、区块链、虚拟现实等领域取得突破，推动游戏与元宇宙的革新。我们注重研发成果的商业化和实际应用，为全球用户提供安全、流畅、创新的“游晰概念”。" },
      { label: "艺术创造", desc: "我们尊重艺术多元化，激发创意潜能，鼓励跨界合作，实现传统文化与现代艺术、游戏设计的融合。我们秉持原创精神，打造独具风格的游戏世界和视觉表达，传递独特的审美体验。" },
      { label: "新文化传播", desc: "我们以开放包容的态度推动文化交流，通过多平台、多形式传播符合时代精神的新文化理念。我们借助数字媒体和社交网络，让全球用户共享优质文化内容与创新体验。" }
    ]
  },
  {
    num: "03",
    title: "实施与管理",
    subTitle: "ACTION",
    paragraphs: [
      { label: "创新驱动", desc: "我们建立跨学科、跨领域的创新团队，鼓励技术与艺术的深度融合，打造符合 future 趋势的游戏产品与文化项目。我们热衷于各种形式的创意交流和行业研讨活动，激发全员的创造力和团队协作精神。" },
      { label: "制度保障", desc: "我们的项目管理依照以人类历史最为透明的普通法系编写的规则执行。我们制定完善的研发、创作与传播标准，确保各环节高效、规范地开展工作。我们建立激励与反馈机制，鼓励成员勇于创新、不断超越，形成良性循环的企业文化。" },
      { label: "市场与合作", desc: "我们积极拓展和研究国内外市场，构建战略合作伙伴关系，携手优秀企业与机构进入游戏业2.0。我们注重品牌塑造，通过不断创新和优质服务打造游晰概念在全球游戏文化与元宇宙领域的领先形象。" }
    ]
  }
];

watch(() => [GlobalStyleStore.CurrentTheme, activeSection.value], () => {
  const isDark = GlobalStyleStore.CurrentTheme === Enum_Theme.Dark;
  const isHome = activeSection.value === 0;

  ThemeTopBarBackgroundColor.value = isHome ? 'transparent' : (isDark ? 'rgba(28, 28, 28, 0.57)' : 'rgba(255, 255, 255, 0.57)');
  ThemeTopBarColor.value = isDark ? '#fff' : '#484848';
  ThemeItemColor.value = isDark ? '#57E1D9' : '#f77373';

  if (isDark) {
    ThemeMainSloganColor.value = '#FFF';
    ThemeMainSloganCruxColor.value = '#57E1D9';
    ThemeSubSlogan.value = '#FFF';
    ThemeIconBackgroundColor.value = '#3fb7b0';
    ThemeIconBackgroundHoverColor.value = '#57E1D9';
    ThemeBottomBG.value = '#242424';
    ThemeBottomPartingLine.value = '#FFFFFF26';
    ThemeCopyrightFiling.value = 'rgba(255,255,255,0.6)';
    ThemeHintColor.value = 'rgba(255,255,255,0.6)';
  } else {
    ThemeMainSloganColor.value = '#545454';
    ThemeMainSloganCruxColor.value = '#f77373';
    ThemeSubSlogan.value = '#1a1a1a';
    ThemeIconBackgroundColor.value = '#de5959';
    ThemeIconBackgroundHoverColor.value = '#f77373';
    ThemeBottomBG.value = '#efefef';
    ThemeBottomPartingLine.value = 'rgba(185,185,185,0.1)';
    ThemeCopyrightFiling.value = 'rgba(0,0,0,0.6)';
    ThemeHintColor.value = 'rgba(0,0,0,0.6)';
  }
}, { immediate: true });

function scrollToSection(index: number) {
  if (scrollContainer.value) {
    const section = scrollContainer.value.querySelector(`#section-${index}`);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

let observer: IntersectionObserver | null = null;
const allAnnouncements = ref<any[]>([]);
const topAnnouncements = ref<any[]>([]);

onMounted(async () => {
  const options = { root: scrollContainer.value, rootMargin: '0px', threshold: 0.5 };
  observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const idParts = entry.target.id.split('-');
        if (idParts.length === 2) {
          activeSection.value = parseInt(idParts[1]);
        }
      }
    });
  }, options);
  document.querySelectorAll('.full-page-section').forEach(sec => observer?.observe(sec));

  const rawData = await fetchAnnouncements();
  const chsList: any[] = [];

  rawData.forEach((item: any) => {
    try {
      const titles = item.title.startsWith('{') ? JSON.parse(item.title) : { chs: item.title };
      const summaries = item.summary.startsWith('{') ? JSON.parse(item.summary) : { chs: item.summary };
      const contents = item.content.startsWith('{') ? JSON.parse(item.content) : { chs: item.content };
      const authors = item.author && item.author.startsWith('{') ? JSON.parse(item.author) : { chs: item.author || '' };

      if(titles.chs) {
        chsList.push({
          ...item,
          title: titles.chs,
          summary: summaries.chs || '',
          author: authors.chs || '',
          content: contents.chs || ''
        });
      }
    } catch(error) {
      console.warn("JSON解析失败, 可能是脏数据", error);
    }
  });

  allAnnouncements.value = chsList;
  topAnnouncements.value = chsList.slice(0, 3);

  // 【新增】===========================================
  // 页面加载完毕后，检测 URL 中是否带有 news_id 参数
  const newsId = route.query.news_id;
  if (newsId) {
    // 查找对应的数据
    const targetNews = allAnnouncements.value.find(item => String(item.id) === String(newsId));
    if (targetNews) {
      // 延迟确保 DOM 挂载完成，然后自动滚动并弹窗
      setTimeout(() => {
        activeSection.value = 2; // 强行激活“新闻动态”导航高亮
        scrollToSection(2);      // 滚动到新闻区块 (section-2)
        openAnnouncementModal(targetNews); // 打开相应的模态框
      }, 500);
    }
  }
  // ===================================================
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});

const isAllListModalVisible = ref(false);

const gameList = ref([
  {
    id: 1, titleCHS: '星梦旅记・域灰之梦', titleEN: 'Star Reverie·Greystasis',
    desc: [
      '灰域蔓延，异梦症肆虐，人类的栖身之所正加速崩塌。',
      '主角在一次偶然的契机中，加入了「纽克托福斯」，成为一名执约者。在与伙伴挽救危局、帮助他人、追寻身世的同时，主角悄然接近着世界的真相。',
      '然而，当象征希望的「梦之源」亦被猩红染指，当噩梦如潮水般吞没现实，时间已所剩无几，承载命运与梦境的容器濒临破碎，神之血终将倾泻尘世——'
    ],
    highlight: '重启，亦或终焉。',
    kvPath: '/Images/Games/Star Reverie/StarReverieKV.png',
    iconPath: '/Images/Games/Star Reverie/StarReverieIcon.png'
  }
]);
const currentGameIndex = ref(0);

function OnUserClickLogo() {
  if (GlobalStyleStore.CurrentTheme === Enum_Theme.Dark) {
    GlobalStyleStore.SetCurrentTheme(Enum_Theme.Light);
  } else {
    GlobalStyleStore.SetCurrentTheme(Enum_Theme.Dark);
  }
}

async function OnCLickEmail() {
  try {
    await navigator.clipboard.writeText("info@lesjeuxa.com");
    alert("已将邮件地址复制到剪贴板，快来联系我们吧(๑′ᴗ‵๑)❤");
  } catch (error) {
    console.error("复制失败", error);
  }
}

function OnCLickX() {
  window.open("https://x.com", "_blank");
}

function OnCLickWeiBo() {
  window.open("https://weibo.com/", "_blank");
}

function OnCLickBilibili() {
  window.open("https://www.bilibili.com/", "_blank");
}

function OnCLickYoutuber() {
  window.open("https://www.youtube.com/@lesjeuxa", "_blank");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_unref(GlobalStyleStore).CurrentTheme===_unref(Enum_Theme).Dark)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: "/Images/Logo.png",
                alt: "Logo",
                onClick: OnUserClickLogo
              }))
            : _createCommentVNode("", true),
          (_unref(GlobalStyleStore).CurrentTheme===_unref(Enum_Theme).Light)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: "/Images/Logo_1.png",
                alt: "Logo",
                onClick: OnUserClickLogo
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["NavBar", { 'hide-on-home': activeSection.value === 0 }])
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['首页', '产品信息', '新闻动态', '了解我们', '加入我们'], (item, index) => {
            return _createElementVNode("span", {
              key: index,
              class: _normalizeClass(["nav-item", { active: activeSection.value === index }]),
              onClick: ($event: any) => (scrollToSection(index))
            }, _toDisplayString(item), 11, _hoisted_5)
          }), 64))
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["Login", { 'hide-on-home': activeSection.value === 0 }])
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("span", { class: "item" }, "注册", -1),
          _createElementVNode("span", { class: "separator" }, "|", -1),
          _createElementVNode("span", { class: "item" }, "登入", -1)
        ]))], 2)
      ])
    ]),
    _createElementVNode("div", {
      class: "ScrollContainer",
      ref_key: "scrollContainer",
      ref: scrollContainer
    }, [
      _createElementVNode("section", {
        id: "section-0",
        class: "full-page-section home-section",
        onMousemove: onHomeMouseMove,
        onMouseleave: onHomeMouseLeave
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(homeBgLayers.value, (layerStyle, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: idx,
            class: "home-parallax-bg",
            style: _normalizeStyle(layerStyle)
          }, null, 4))
        }), 128)),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "home-vignette-overlay" }, null, -1)),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(60, (n) => {
            return _createElementVNode("div", {
              class: "particle",
              key: n
            })
          }), 64))
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "overlay",
          style: {"z-index":"10"}
        }, null, -1)),
        _createElementVNode("div", {
          class: "scroll-hint",
          style: {"z-index":"11","cursor":"pointer"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollToSection(1)))
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("p", null, "向下滚动查看更多", -1),
          _createElementVNode("div", { class: "arrow-down" }, null, -1)
        ]))])
      ], 32),
      _createElementVNode("section", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass(["product-container", { 'is-active': activeSection.value === 1 }])
        }, [
          _createElementVNode("div", _hoisted_8, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "dot" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(gameList.value[currentGameIndex.value].titleEN.toUpperCase()) + " ", 1),
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "dot" }, null, -1)),
            _cache[10] || (_cache[10] = _createTextVNode(" LESJEUXA", -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(), _createElementBlock("img", {
                src: gameList.value[currentGameIndex.value].kvPath,
                class: "product-kv",
                key: currentGameIndex.value
              }, null, 8, _hoisted_11))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h1", _hoisted_13, _toDisplayString(gameList.value[currentGameIndex.value].titleCHS), 1),
            _createElementVNode("h3", _hoisted_14, _toDisplayString(gameList.value[currentGameIndex.value].titleEN), 1),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameList.value[currentGameIndex.value].desc, (paragraph, i) => {
                return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(paragraph), 1))
              }), 128)),
              _createElementVNode("p", _hoisted_16, _toDisplayString(gameList.value[currentGameIndex.value].highlight), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameList.value, (game, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: game.id,
                class: _normalizeClass(["game-list-item", { 'is-selected': currentGameIndex.value === index }]),
                onClick: ($event: any) => (currentGameIndex.value = index)
              }, [
                _createElementVNode("img", {
                  src: game.iconPath
                }, null, 8, _hoisted_19)
              ], 10, _hoisted_18))
            }), 128))
          ])
        ], 2)
      ]),
      _createElementVNode("section", {
        id: "section-2",
        class: _normalizeClass(["full-page-section content-section", { 'is-active': activeSection.value === 2 }])
      }, [
        (topAnnouncements.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topAnnouncements.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "anim-item",
                  style: _normalizeStyle({ 'transition-delay': `${index * 0.2}s` })
                }, [
                  _createVNode(InfoBox_Left, {
                    Title: item.title,
                    Summary: item.summary,
                    ImagePath: item.cover_image,
                    onOpenModal: ($event: any) => (openAnnouncementModal(item))
                  }, null, 8, ["Title", "Summary", "ImagePath", "onOpenModal"])
                ], 4))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[11] || (_cache[11] = [
              _createElementVNode("p", null, "暂无最新动态", -1)
            ]))])),
        (allAnnouncements.value.length > 3)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "more-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (isAllListModalVisible.value = true))
            }, [...(_cache[12] || (_cache[12] = [
              _createTextVNode(" More ", -1),
              _createElementVNode("span", null, "+", -1)
            ]))]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("section", {
        id: "section-3",
        class: _normalizeClass(["full-page-section content-section learn-us-section", { 'is-active': activeSection.value === 3 }])
      }, [
        _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"about-header-slogan\" data-v-9bf017e8><h1 class=\"brand-core-slogan\" data-v-9bf017e8><span class=\"highlight-cyan\" data-v-9bf017e8>技术</span>研发 • <span class=\"highlight-cyan\" data-v-9bf017e8>艺术</span>创造 • <span class=\"highlight-cyan\" data-v-9bf017e8>新文化</span>传播 </h1><p class=\"brand-core-desc\" data-v-9bf017e8> LESJEUXA 始终致力于前沿科技与艺术美学的交融，为数字时代提供卓尔不群的「游晰方案」 </p></div>", 1)),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(aboutTabsData, (tab, index) => {
              return _createElementVNode("div", {
                key: index,
                class: _normalizeClass(["about-nav-card", { 'is-active': activeAboutTab.value === index }]),
                onClick: ($event: any) => (activeAboutTab.value = index)
              }, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(tab.num), 1),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, _toDisplayString(tab.title), 1),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(tab.subTitle), 1)
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-glow-bar" }, null, -1))
              ], 10, _hoisted_24)
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_29, [
            (_openBlock(), _createElementBlock("div", {
              class: "details-viewport",
              key: activeAboutTab.value
            }, [
              _createElementVNode("h2", _hoisted_30, _toDisplayString(aboutTabsData[activeAboutTab.value].title) + "纲要", 1),
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "viewport-divider" }, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutTabsData[activeAboutTab.value].paragraphs, (para, pIdx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: pIdx,
                  class: "content-row",
                  style: _normalizeStyle({ 'animation-delay': `${pIdx * 0.15}s` })
                }, [
                  _createElementVNode("div", _hoisted_31, [
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "row-indicator" }, null, -1)),
                    _createElementVNode("h4", _hoisted_32, _toDisplayString(para.label), 1)
                  ]),
                  _createElementVNode("p", _hoisted_33, _toDisplayString(para.desc), 1)
                ], 4))
              }), 128))
            ]))
          ])
        ])
      ], 2),
      _createElementVNode("section", {
        id: "section-4",
        class: _normalizeClass(["full-page-section end-section", { 'is-active': activeSection.value === 4 }])
      }, [
        _createElementVNode("div", { class: "join-content" }, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "join-text-group" }, [
            _createElementVNode("h2", { class: "join-title" }, [
              _createTextVNode("加入我们 / "),
              _createElementVNode("span", { class: "highlight-text" }, "JOIN US")
            ]),
            _createElementVNode("p", { class: "join-subtitle" }, "期待您的才华，与我们共同编织下一个梦境。")
          ], -1)),
          _createElementVNode("div", { class: "contact-anim-box" }, [
            _createElementVNode("div", {
              class: "contact-wrapper",
              onClick: OnCLickEmail
            }, [...(_cache[17] || (_cache[17] = [
              _createElementVNode("div", { class: "contact-label" }, "MAIL TO US", -1),
              _createElementVNode("div", { class: "contact-email" }, "info@lesjeuxa.com", -1),
              _createElementVNode("div", { class: "contact-hover-line" }, null, -1),
              _createElementVNode("div", { class: "contact-hint" }, "CLICK TO COPY / 点击复制邮箱地址", -1)
            ]))])
          ])
        ]),
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "BottomBG" }, [
          _createElementVNode("div", { class: "BottomPartingLine" }),
          _createElementVNode("div", { class: "BottomContent" }, [
            _createElementVNode("div", { class: "CopyrightFiling" }, "Copyright 2021-2026 LESJEUXA.COM 遊晰概念有限公司")
          ])
        ], -1))
      ], 2)
    ], 512),
    _createVNode(AnnouncementModal, {
      visible: isModalVisible.value,
      announcement: currentAnnouncementData.value,
      onClose: closeAnnouncementModal
    }, null, 8, ["visible", "announcement"]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (isAllListModalVisible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", {
                  class: "close-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (isAllListModalVisible.value = false))
                }, [
                  _createVNode(_unref(AnOutlinedClose))
                ]),
                _cache[20] || (_cache[20] = _createElementVNode("h2", { style: {"color":"black","margin-bottom":"30px"} }, "全部动态", -1)),
                _createElementVNode("div", _hoisted_36, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allAnnouncements.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "simple-list-item",
                      key: item.id,
                      onClick: ($event: any) => (openAnnouncementModal(item))
                    }, [
                      _createElementVNode("img", {
                        src: item.cover_image,
                        class: "slim-cover"
                      }, null, 8, _hoisted_38),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                        _createElementVNode("p", null, _toDisplayString(item.summary), 1)
                      ])
                    ], 8, _hoisted_37))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", {
      class: "global-scroll-hint",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (scrollToSection(activeSection.value + 1)))
    }, [...(_cache[21] || (_cache[21] = [
      _createElementVNode("div", { class: "arrow-down" }, null, -1)
    ]))], 512), [
      [_vShow, activeSection.value > 0 && activeSection.value < 4]
    ])
  ]))
}
}

})